import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[sanitizeInput]',
})

export class SanitizeInputDirective {
    constructor(private el: ElementRef) {}

    // Listen for input events on the element
    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        const inputElement = this.el.nativeElement as HTMLInputElement;
        let sanitizedValue = this.sanitize(inputElement.value);

        // Update the input value if it was modified
        if (sanitizedValue !== inputElement.value) {
            inputElement.value = sanitizedValue;
        }
    }

    // Handle paste events
    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        const inputElement = this.el.nativeElement as HTMLInputElement;

        // Get the pasted content from the clipboard
        const pastedContent = event.clipboardData?.getData('text') || '';

        // Sanitize the pasted content
        const sanitizedContent = this.sanitize(pastedContent);

        // Prevent the default paste action
        event.preventDefault();

        // Insert the sanitized content into the input field
        const start = inputElement.selectionStart || 0;
        const end = inputElement.selectionEnd || 0;
        const currentValue = inputElement.value;

        // Replace the selected text with the sanitized content
        const updatedValue = currentValue.substring(0, start) + sanitizedContent + currentValue.substring(end);
        inputElement.value = updatedValue;

        // Manually trigger the input event to notify Angular's two-way binding
        inputElement.dispatchEvent(new Event('input'));
    }

    // Function to sanitize the input value
    private sanitize(value: string): string {
        // Remove <script> tags and their content
        return value.replace(/<script.*?>.*?<\/script>/gim, '')
              .replace(/<iframe.*?>.*?<\/iframe>/gim, '')
              .replace(/<\/?[^>]+(>|$)/g, ''); // Remove all tags
    }
}